import React from 'react';
import { IconProps } from './model/IconInterface';

const MessageSquareIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24'
       fill='none' stroke={color}
       strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
  </svg>
);

export default MessageSquareIcon;
